import React from 'react';
import './App.css';
import Calculator from './_components/Calculator';



function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Calculator />
      </header>
    </div>
  );
}

export default App;
